import {
  Button,
  ButtonProps,
  ButtonSize,
  H3,
  MOBILE_MAX,
  mediaHelper,
  spacingHelper,
  typographyHelper,
} from '@property.com.au/ui-kit';
import { type FunctionComponent } from 'react';
import styled from 'styled-components';
import { trackModalImpression } from '../../../../../analytics/event-tracking/trackModalImpression';
import { ContentBrick } from '../../../../../app-kit/components/ContentBrick/ContentBrick';
import { ButtonVariant, mapButtonVariant } from '../../../../../app-kit/helpers/mapButtonVariant';
import {
  FeatureCollection,
  FeatureItem,
} from '../../../../../components/FeatureCollection/FeatureCollection';
import { usePropertyPageModalContext } from '../../../../contexts/PropertyPageModalContext/PropertyPageModalContext';

export type Cta = {
  button: Omit<ButtonProps, 'sizeVariant' | 'iconPlacement' | 'variant'> & {
    text?: string;
    sizeVariant?: ButtonSize | null;
    buttonVariant: ButtonVariant;
  };
};

type UpdatePropertiesDetailsProps = {
  cta: Cta;
};

interface PropertySubFeaturesBrickProps {
  title: string;
  subtitle: string;
  features: FeatureItem[];
  updatePropertyDetails?: UpdatePropertiesDetailsProps | null;
}

const StyledH3 = styled(H3)`
  ${typographyHelper('body01Bold')}
`;

const StyledButton = styled(Button)`
  margin-top: ${spacingHelper('medium')};
  ${mediaHelper('mobile')} {
    width: 100%;
  }
`;

export const PropertySubFeaturesBrick: FunctionComponent<PropertySubFeaturesBrickProps> = ({
  title,
  subtitle,
  features,
  updatePropertyDetails,
}) => {
  const { displayModal } = usePropertyPageModalContext();

  return (
    <ContentBrick
      title={title}
      titleComponent={<StyledH3 variant="subtitle01">{title}</StyledH3>}
      subtitle={subtitle}
      isSubBrick={true}
    >
      <FeatureCollection features={features} />
      {updatePropertyDetails && (
        <StyledButton
          variant={mapButtonVariant(updatePropertyDetails.cta.button.buttonVariant)}
          iconPlacement={undefined}
          sizeVariant={updatePropertyDetails.cta.button.sizeVariant ?? 'medium'}
          onClick={() => {
            trackModalImpression({
              user_action: 'opened',
              modal_name: 'update_property_details',
              screen_name: 'property_details',
              modal_is_fullscreen: window.innerWidth <= MOBILE_MAX + 1,
              in_page_source: 'property_page_property_features_brick',
            });
            displayModal({ name: 'updatePropertyDetailsModal' });
          }}
        >
          {updatePropertyDetails.cta.button.text}
        </StyledButton>
      )}
    </ContentBrick>
  );
};
